const TermsOfServiceModule = () => import('@/modules/TermsOfService')

export default [
	{
		component: TermsOfServiceModule,
		name: 'specific-terms-of-service',
		path: 'terms-of-service'
	}
]
